import React from 'react'
import {ReactComponent as DividerCurve} from '../../../images/shapes/curves/curve-2.svg'
import {ReactComponent as BottomDivider} from '../../../images/shapes/curves/curve-1.svg'

export function AboutPageContent() {
  return (
    <>
      <section className="py-5 bg-primary">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 text-center">
              <h1 className="display-2 text-white">About</h1>
              <p className="lead text-white mb-5">
                What to expect? We're here to help you better understand Coliberty.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x svg-shim text-light">
          <DividerCurve />
        </div>
      </div>

      <div className="bg-light py-5">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">Guided forms</h5>
                  <p className="card-text">Quickly and accurately complete forms with expert guidance built in.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">Requested Authorisation management</h5>
                  <p className="card-text">
                    Simple workflow allows quick resolution of requested authorisations, easy task assignments and leads
                    to better outcomes with better collaboration support.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">Open collaboration</h5>
                  <p className="card-text">
                    Draft, review, comment and approve contributions from inside and outside your organisation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">State-of-the-art notifications</h5>
                  <p className="card-text">
                    Keep collaborators engaged and stakeholders informed with notifications via e-mail and push
                    messaging.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">Controlled data sharing</h5>
                  <p className="card-text">
                    Request access to relevant historic requested authorisation data held by other responsible bodies.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card about-card-height border-white mb-5 shadow-sm rounded lift lift-lg">
                <div className="card-body">
                  <h5 className="card-title">Automated statutory returns</h5>
                  <p className="card-text">
                    Dramatically cut down the effort required to meet your statutory reporting obligations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-relative mb-5">
        <div className="shape shape-bottom shape-fluid-x svg-shim bg-light text-white">
          <BottomDivider />
        </div>
      </div>
    </>
  )
}
